<script lang="ts">
  import { Button, Col } from "sveltestrap";
  import { Subscribe, href } from "../../../../utils/Constant/Constant";
  import data from "../../../../Data/Ecommerce/Ecommerce.json"
</script>
{#each data.pricingData as pricingItem}
    <Col md="3">
        <div class="pricing-block card text-center">
            <div class="pricing-header">
                <h2>{pricingItem.title}</h2>
                <div class="price-box">
                    <div>
                        <h3>$ {pricingItem.amount}</h3>
                        <p>{'/ month'}</p>
                    </div>
                </div>
            </div>
            <div class="pricing-list"> 
                <ul class="pricing-inner">
                    {#each pricingItem.content as subItem}
                        <li>
                            <h6>{subItem.space}
                                <span>{subItem.detail}</span>
                            </h6>
                        </li>
                    {/each}
                </ul>
                <Button color="primary" size="lg" href={href}>{Subscribe}</Button>
            </div>
        </div>
    </Col>
{/each}